import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getCompanyDetails = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/company-details/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Company details fetch error:", error);
    throw error;
  }
};

const updateCompanyDetails = async (data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/company-details/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Company details update error:", error);
    throw error;
  }
};

const deleteCompanyDocument = async (documentId) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/company-details/?document_id=${documentId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Company document delete error:", error);
    throw error;
  }
};

export { getCompanyDetails, updateCompanyDetails, deleteCompanyDocument };
